export default { duration: 0.8, ease: [0.6, 0.01, -0.05, 0.9] };
